import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
export type TenantScopeOption = {
  value: TenantScope['kind'];
  label: string;
};
type OptionGroup = {
  label: string;
  options: TenantScopeOption[];
};
const useTenantScopeOptions = () => {
  const $ = _c(93);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "scopes"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("roles", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      value: "admin",
      label: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      value: "api_keys",
      label: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      value: "auth_token",
      label: t5
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp4);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      value: "org_settings",
      label: t7
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp5);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      value: "write_entities",
      label: t9
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp6);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      value: "onboarding",
      label: t11
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp7);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = {
      value: "onboarding_configuration",
      label: t13
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp8);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = {
      value: "manage_webhooks",
      label: t15
    };
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t12 || $[35] !== t14 || $[36] !== t16 || $[37] !== t2 || $[38] !== t4 || $[39] !== t6 || $[40] !== t8) {
    t17 = {
      label: "Basic Permissions",
      options: [t2, t4, t6, t8, t10, t12, t14, t16]
    };
    $[33] = t10;
    $[34] = t12;
    $[35] = t14;
    $[36] = t16;
    $[37] = t2;
    $[38] = t4;
    $[39] = t6;
    $[40] = t8;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t) {
    t18 = t(_temp9);
    $[42] = t;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t18) {
    t19 = {
      value: "decrypt_all",
      label: t18
    };
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t) {
    t20 = t(_temp10);
    $[46] = t;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t20) {
    t21 = {
      value: "decrypt_custom",
      label: t20
    };
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t) {
    t22 = t(_temp11);
    $[50] = t;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t22) {
    t23 = {
      value: "decrypt_document",
      label: t22
    };
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t) {
    t24 = t(_temp12);
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t24) {
    t25 = {
      value: "decrypt_document_and_selfie",
      label: t24
    };
    $[56] = t24;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t19 || $[59] !== t21 || $[60] !== t23 || $[61] !== t25) {
    t26 = {
      label: "Decrypt Permissions",
      options: [t19, t21, t23, t25]
    };
    $[58] = t19;
    $[59] = t21;
    $[60] = t23;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== t) {
    t27 = t(_temp13);
    $[63] = t;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== t27) {
    t28 = {
      value: "manual_review",
      label: t27
    };
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t) {
    t29 = t(_temp14);
    $[67] = t;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== t29) {
    t30 = {
      value: "trigger_kyc",
      label: t29
    };
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== t) {
    t31 = t(_temp15);
    $[71] = t;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t31) {
    t32 = {
      value: "trigger_kyb",
      label: t31
    };
    $[73] = t31;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== t) {
    t33 = t(_temp16);
    $[75] = t;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] !== t33) {
    t34 = {
      value: "cip_integration",
      label: t33
    };
    $[77] = t33;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== t28 || $[80] !== t30 || $[81] !== t32 || $[82] !== t34) {
    t35 = {
      label: "Compliance Permissions",
      options: [t28, t30, t32, t34]
    };
    $[79] = t28;
    $[80] = t30;
    $[81] = t32;
    $[82] = t34;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== t) {
    t36 = t(_temp17);
    $[84] = t;
    $[85] = t36;
  } else {
    t36 = $[85];
  }
  let t37;
  if ($[86] !== t36) {
    t37 = {
      label: "Proxy Permissions",
      options: [{
        value: "manage_vault_proxy",
        label: t36
      }]
    };
    $[86] = t36;
    $[87] = t37;
  } else {
    t37 = $[87];
  }
  let t38;
  if ($[88] !== t17 || $[89] !== t26 || $[90] !== t35 || $[91] !== t37) {
    const options = [t17, t26, t35, t37];
    const tenantScopeFromOption = _temp18;
    t38 = {
      options,
      tenantScopeFromOption
    };
    $[88] = t17;
    $[89] = t26;
    $[90] = t35;
    $[91] = t37;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  return t38;
};
export default useTenantScopeOptions;
function _temp($) {
  return $.admin;
}
function _temp2($_0) {
  return $_0.api_keys;
}
function _temp3($_1) {
  return $_1.auth_token;
}
function _temp4($_2) {
  return $_2.org_settings;
}
function _temp5($_3) {
  return $_3.write_entities;
}
function _temp6($_4) {
  return $_4.onboarding;
}
function _temp7($_5) {
  return $_5.onboarding_configuration;
}
function _temp8($_6) {
  return $_6.manage_webhooks;
}
function _temp9($_7) {
  return $_7.decrypt_all;
}
function _temp10($_8) {
  return $_8.decrypt_custom;
}
function _temp11($_9) {
  return $_9.decrypt_documents;
}
function _temp12($_10) {
  return $_10.decrypt_document_and_selfie;
}
function _temp13($_11) {
  return $_11.manual_review;
}
function _temp14($_12) {
  return $_12.trigger_kyc;
}
function _temp15($_13) {
  return $_13.trigger_kyb;
}
function _temp16($_14) {
  return $_14.cip_integration;
}
function _temp17($_15) {
  return $_15.manage_vault_proxy;
}
function _temp18(option) {
  return {
    kind: option
  } as TenantScope;
}